import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { selecionarBairro } from '../../app/slices/bairroTotemSlice';
import { selectCidade } from '../../app/slices/cidadesSlice';
import { fecharModalAjuda, fecharModalBairro, selectModal } from '../../app/slices/modalSlice';
import { ContainerJanela, Divisor, Linha } from '../../styles/base';
import { replaceTags } from '../../util/stringFactory';
import Carregar from '../Carregar/Carregar';
import Botao from '../Botao/Botao';
import { Ajuda, JanelaAjuda, TituloAjuda } from './ModalBairroEstilo';

const ModalBairro = () => {
  const dispatch = useDispatch();
  const dadosCidade = useSelector(selectCidade);
  const dadosModal = useSelector(selectModal);
  const [bairro, setBairro] = useState({});
  const [bairros, setBairros] = useState([]);
  const [carregar, setCarregar] = useState(false);

  useEffect(() => {
    setBairros(dadosModal.bairros.bairros);
  }, []);

  return (
    <ContainerJanela onClick={() => dispatch(fecharModalBairro())}>
      <JanelaAjuda onClick={(e) => e.stopPropagation()}>
        <Linha style={{ justifyContent: 'flex-end', padding: '10px 0px' }}>
          <Botao
            style={{ padding: '15px', position: 'absolute', marginRight: -10 }}
            fecharTotem
            onClick={() => dispatch(fecharModalBairro())}
          />
        </Linha>

        <TituloAjuda>Selecione o bairro: </TituloAjuda>

        <div
          id="modalBairroBox"
          style={{
            display: 'grid', gridTemplateColumns: '1fr', maxHeight: 650, overflow: 'scroll', overflowX: 'hidden', overflowY: 'hidden', marginBottom: 10, border: '1px solid #e5e5e5', padding: '20px 0',
          }}
        >
          {(bairros.length > 10) && (
            <>
              <Botao
                onClick={() => document.getElementById('modalBairroBox').scrollBy({
                  top: -600,
                  left: 0,
                  behavior: 'smooth',
                })}
                totemUpModal
              />
              <Botao
                onClick={() => document.getElementById('modalBairroBox').scrollBy({
                  top: 600,
                  left: 0,
                  behavior: 'smooth',
                })}
                totemDownModal
              />
            </>
          )}
          {(bairros) && (
            bairros.map((bair) => (
              <label
                htmlFor={bair.Id}
                key={bair.id}
                style={{
                  padding: 15, display: 'flex', /* maxWidth: 400, */ fontSize: '1.35em', gap: 10, alignItems: 'center',
                }}
              >
                <input
                  type="radio"
                  id={bair.Id}
                  style={{
                    marginRight: 7, padding: 10, width: 23, height: 23,
                  }}
                  value={bair.Campo}
                  name="bairros"
                  defaultChecked={bairros.length === 1} // Marcar o radio por padrão se houver apenas 1 item
                  onClick={(e) => {
                    setTimeout(() => {
                      dispatch(selecionarBairro({ bairro: e.target.value, bairroId: bair.Id })); dispatch(fecharModalBairro());
                    }, 100);
                  }}
                />
                {bair.Campo}
              </label>
            ))
          )}
        </div>
      </JanelaAjuda>
    </ContainerJanela>
  );
};

export default ModalBairro;
